import { render, staticRenderFns } from "./StudioSocial.vue?vue&type=template&id=1505d3c2&scoped=true&"
import script from "./StudioSocial.vue?vue&type=script&lang=ts&"
export * from "./StudioSocial.vue?vue&type=script&lang=ts&"
import style0 from "./StudioSocial.vue?vue&type=style&index=0&id=1505d3c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1505d3c2",
  null
  
)

export default component.exports